exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disc-lists[data-v-15c136d2]{list-style:disc;margin-left:25px}", ""]);

// exports
